/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Metric_Total_Products_HintInputs */

const en_inventory_metric_total_products_hint = /** @type {(inputs: Inventory_Metric_Total_Products_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active products in system`)
};

const es_inventory_metric_total_products_hint = /** @type {(inputs: Inventory_Metric_Total_Products_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productos activos en el sistema`)
};

/**
* | output |
* | --- |
* | "Active products in system" |
*
* @param {Inventory_Metric_Total_Products_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_metric_total_products_hint = /** @type {((inputs?: Inventory_Metric_Total_Products_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Metric_Total_Products_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_metric_total_products_hint(inputs)
	return es_inventory_metric_total_products_hint(inputs)
});